export default __webpack_public_path__ + "tmp_src/components/Accordion/Accordion.css.liquid";